<template>
  <h1>Invoices</h1>
</template>
